import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { PsqiUpdate } from "./PsqiUpdate";

import { CreditoUpdate } from "../components/CreditoUpdate";

import { GananciasModal } from "../components/GananciasModal";

import * as APILOG from "../services/gananciaslog";

import * as APIUSER from "../services/user";

export function PsqiPacienteEdit(props) {
  const psqi = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = psqi.message;

  // mensaje de advertencia al no contstar a las preguntas necesarias del formulario
  const [missingQuestionsMessage, setMissingQuestionsMessage] = useState("");
  const [isMissingQuestionsModalOpen, setIsMissingQuestionsModalOpen] =
    useState(false);

  const [isGananciasModalOpen, setIsGananciasModalOpen] = useState(false);
  const [gananciasMessage, setGananciasMessage] = useState("");

  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const [credito, setCredito] = useState(0);
  const [pacienteId, setPacienteId] = useState(0);

  const [psqiResp, setPsqiResp] = useState(psqi.meta?.psqiResp);
  const [metaFecha, setPsqiFecha] = useState(psqi.meta?.metaFecha);
  const [psqiPreg001, setPsqiPreg001] = useState(psqi.meta?.psqiPreg001);
  const [psqiPreg002, setPsqiPreg002] = useState(psqi.meta?.psqiPreg002);
  const [psqiPreg003, setPsqiPreg003] = useState(psqi.meta?.psqiPreg003);
  const [psqiPreg004, setPsqiPreg004] = useState(psqi.meta?.psqiPreg004);
  const [psqiPreg005a, setPsqiPreg005a] = useState(psqi.meta?.psqiPreg005a);
  const [psqiPreg005b, setPsqiPreg005b] = useState(psqi.meta?.psqiPreg005b);
  const [psqiPreg005c, setPsqiPreg005c] = useState(psqi.meta?.psqiPreg005c);
  const [psqiPreg005d, setPsqiPreg005d] = useState(psqi.meta?.psqiPreg005d);
  const [psqiPreg005e, setPsqiPreg005e] = useState(psqi.meta?.psqiPreg005e);
  const [psqiPreg005f, setPsqiPreg005f] = useState(psqi.meta?.psqiPreg005f);
  const [psqiPreg005g, setPsqiPreg005g] = useState(psqi.meta?.psqiPreg005g);
  const [psqiPreg005h, setPsqiPreg005h] = useState(psqi.meta?.psqiPreg005h);
  const [psqiPreg005i, setPsqiPreg005i] = useState(psqi.meta?.psqiPreg005i);
  const [psqiPreg005j, setPsqiPreg005j] = useState(psqi.meta?.psqiPreg005j);
  const [psqiPreg005k, setPsqiPreg005k] = useState(psqi.meta?.psqiPreg005k);
  const [psqiPreg006, setPsqiPreg006] = useState(psqi.meta?.psqiPreg006);
  const [psqiPreg007, setPsqiPreg007] = useState(psqi.meta?.psqiPreg007);
  const [psqiPreg008, setPsqiPreg008] = useState(psqi.meta?.psqiPreg008);
  const [psqiPreg009, setPsqiPreg009] = useState(psqi.meta?.psqiPreg009);
  const [psqiPreg010, setPsqiPreg010] = useState(psqi.meta?.psqiPreg010);
  const [psqiPreg010a, setPsqiPreg010a] = useState(psqi.meta?.psqiPreg010a);
  const [psqiPreg010b, setPsqiPreg010b] = useState(psqi.meta?.psqiPreg010b);
  const [psqiPreg010c, setPsqiPreg010c] = useState(psqi.meta?.psqiPreg010c);
  const [psqiPreg010d, setPsqiPreg010d] = useState(psqi.meta?.psqiPreg010d);
  const [psqiPreg010e, setPsqiPreg010e] = useState(psqi.meta?.psqiPreg010e);
  const [psqiPreg010f, setPsqiPreg010f] = useState(psqi.meta?.psqiPreg010f);
  let { tratamientoId } = useParams();

  let psqiId = psqi.id;
  let psqiStatus = psqi.status;

  const psqiDate = new Date(psqi.date);
  const diffDate = Math.abs(new Date() - psqiDate) / 36e5;

  // Nuevos estados para el Modal de Error
  const [errorModalMessage, setErrorModalMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  // Definir el array de preguntas
  const psqiQuestions = [
    "psqiPreg001",
    "psqiPreg002",
    "psqiPreg003",
    "psqiPreg004",
    "psqiPreg005a",
    "psqiPreg005b",
    "psqiPreg005c",
    "psqiPreg005d",
    "psqiPreg005e",
    "psqiPreg005f",
    "psqiPreg005g",
    "psqiPreg005h",
    "psqiPreg005i",
    "psqiPreg005j",
    "psqiPreg005k",
    "psqiPreg006",
    "psqiPreg007",
    "psqiPreg008",
    "psqiPreg009",
    "psqiPreg010",
    "psqiPreg010a",
    "psqiPreg010b",
    "psqiPreg010c",
    "psqiPreg010d",
    "psqiPreg010e",
    "psqiPreg010f",
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Obtener los datos del usuario
        const currentUserData = await APIUSER.getCurrentUser();
        console.log(currentUserData);
        if (currentUserData) {
          setCredito(currentUserData?.meta?.credito);
          setPacienteId(currentUserData?.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };

    fetchUserData();
  }, []);

  // const submitPsqi = async (e) => {
  //   e.preventDefault();
  //   setIsCreatingButton(true);
  //   try {
  //     await PsqiUpdate(
  //       psqiResp,
  //       metaFecha,
  //       psqiPreg001,
  //       psqiPreg002,
  //       psqiPreg003,
  //       psqiPreg004,
  //       psqiPreg005a,
  //       psqiPreg005b,
  //       psqiPreg005c,
  //       psqiPreg005d,
  //       psqiPreg005e,
  //       psqiPreg005f,
  //       psqiPreg005g,
  //       psqiPreg005h,
  //       psqiPreg005i,
  //       psqiPreg005j,
  //       psqiPreg005k,
  //       psqiPreg006,
  //       psqiPreg007,
  //       psqiPreg008,
  //       psqiPreg009,
  //       psqiPreg010,
  //       psqiPreg010a,
  //       psqiPreg010b,
  //       psqiPreg010c,
  //       psqiPreg010d,
  //       psqiPreg010e,
  //       psqiPreg010f,
  //       tratamientoId,
  //       pacienteId,
  //       psqiId
  //     ).then(
  //       (val) => {
  //         try {
  //           // Verificar que `credito` sea un número antes de sumarle 10
  //           const creditoFinal = typeof credito === 'number' ? credito + 10 : 10;

  //           CreditoUpdate(
  //             creditoFinal,
  //             pacienteId
  //           ).then(
  //             (val) => {
  //               console.log(val);
  //               window.location.replace(`../`);
  //             },
  //             (error) => {
  //               console.log(error);
  //             }
  //           );
  //         } catch (err) {
  //           console.log(err);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const submitPsqi = async (e) => {
    e.preventDefault();
    setMissingQuestionsMessage("");
    setIsMissingQuestionsModalOpen(false);
    setIsCreatingButton(true);
    setErrorModalMessage(""); // Reiniciar mensaje de error

    try {
      // Crear un objeto que mapea cada pregunta con su valor actual
      const psqiQuestionValues = {
        psqiPreg001,
        psqiPreg002,
        psqiPreg003,
        psqiPreg004,
        psqiPreg005a,
        psqiPreg005b,
        psqiPreg005c,
        psqiPreg005d,
        psqiPreg005e,
        psqiPreg005f,
        psqiPreg005g,
        psqiPreg005h,
        psqiPreg005i,
        // psqiPreg005j,
        psqiPreg005k,
        psqiPreg006,
        psqiPreg007,
        psqiPreg008,
        psqiPreg009,
        psqiPreg010,
        psqiPreg010a,
        psqiPreg010b,
        psqiPreg010c,
        psqiPreg010d,
        // psqiPreg010e,
        psqiPreg010f,
      };

      const requiredQuestions = [
        "psqiPreg001",
        "psqiPreg002",
        "psqiPreg003",
        "psqiPreg004",
        "psqiPreg005a",
        "psqiPreg005b",
        "psqiPreg005c",
        "psqiPreg005d",
        "psqiPreg005e",
        "psqiPreg005f",
        "psqiPreg005g",
        "psqiPreg005h",
        "psqiPreg005i",
        // "psqiPreg005k", no requerido 04/25
        "psqiPreg006",
        "psqiPreg007",
        "psqiPreg008",
        "psqiPreg009",
      ];

      // Validación: revisamos solo las preguntas obligatorias
      const allRequiredAnswered = requiredQuestions.every(
        (question) => psqiQuestionValues[question] !== ""
      );

      if (!allRequiredAnswered) {
        // Si alguna de esas preguntas obligatorias no está contestada, lanzamos el error
        setMissingQuestionsMessage(
          "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas."
        );
        setIsMissingQuestionsModalOpen(true); // Abrir el modal de error
        setIsCreatingButton(false);
        return; // Evitar el envío del formulario
      }

      // // Contar cuántas preguntas han sido respondidas
      // const answeredQuestions = psqiQuestions.filter(
      //   (question) => psqiQuestionValues[question] !== ""
      // ).length;

      // // Calcular el porcentaje de respuestas completadas
      // const totalQuestions = psqiQuestions.length;
      // const percentage = (answeredQuestions / totalQuestions) * 100;

      // if (percentage < 95) {
      //   setErrorModalMessage(
      //     "Necesitas contestar al menos el 95% de las preguntas para enviar este cuestionario."
      //   );
      //   setIsErrorModalOpen(true); // Abrir el modal de error
      //   setIsCreatingButton(false);
      //   return; // Evitar el envío del formulario
      // }

      // Si la validación pasa, proceder con el envío
      await PsqiUpdate(
        psqiResp,
        metaFecha,
        psqiPreg001,
        psqiPreg002,
        psqiPreg003,
        psqiPreg004,
        psqiPreg005a,
        psqiPreg005b,
        psqiPreg005c,
        psqiPreg005d,
        psqiPreg005e,
        psqiPreg005f,
        psqiPreg005g,
        psqiPreg005h,
        psqiPreg005i,
        psqiPreg005j,
        psqiPreg005k,
        psqiPreg006,
        psqiPreg007,
        psqiPreg008,
        psqiPreg009,
        psqiPreg010,
        psqiPreg010a,
        psqiPreg010b,
        psqiPreg010c,
        psqiPreg010d,
        psqiPreg010e,
        psqiPreg010f,
        tratamientoId,
        pacienteId,
        psqiId
      ).then(
        (val) => {
          try {
            // Verificar que `credito` sea un número antes de sumarle 10
            const creditoFinal =
              typeof credito === "number" ? credito + 10 : 10;

            CreditoUpdate(creditoFinal, pacienteId).then(
              (val) => {
                console.log("Crédito actualizado:", val);
                // Luego de actualizar el crédito, creamos el log.
                const fechaActual = new Date().toISOString();
                APILOG.createGananciasLog(
                  fechaActual,
                  pacienteId,
                  "Completó el cuestionario PSQI. + 10€"
                )
                  .then((val) => {
                    console.log(val);
                    // window.location.replace(`../`);
                    setGananciasMessage(
                      "Ha obtenido 10€ y se lo hemos añadido a sus Ganancias"
                    );
                    setIsGananciasModalOpen(true);
                  })
                  .catch((error) => {
                    console.error("Error al crear ganancias log:", error);
                    // En caso de error, aun redirigimos o podemos mostrar un mensaje
                    // window.location.replace(`../`);
                    setGananciasMessage(
                      "Ha obtenido 10€ y se lo hemos añadido a sus Ganancias"
                    );
                    setIsGananciasModalOpen(true);
                  });
              },
              (error) => {
                console.log(error);
                setIsCreatingButton(false);
              }
            );
          } catch (err) {
            console.log(err);
            setIsCreatingButton(false);
          }
        },
        (error) => {
          console.log(error);
          setIsCreatingButton(false);
        }
      );
    } catch (err) {
      console.log(err);
      setIsCreatingButton(false);
    }
  };

  return (
    <>
      <div id="content">
        {/* Modal de Advertencia al no contestar preguntas necesarias */}
        {isMissingQuestionsModalOpen && (
          <div
            className={`modal ${
              isMissingQuestionsModalOpen ? "is-active" : ""
            }`}
          >
            <div
              className="modal-background"
              onClick={() => setIsMissingQuestionsModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">
                {missingQuestionsMessage}
              </section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}
        {psqi.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : psqi.author !== pacienteId ? ( // Comprobación del autor
          <p>Error: No tienes permiso para editar este contenido.</p>
        ) : (
          <form
            id="formUpdatelement"
            className="newRadioButtons"
            onSubmit={submitPsqi}
          >
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="metaFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="metaFecha"
                      required
                      type="date"
                      value={metaFecha}
                      onChange={(e) => setPsqiFecha(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario de Sueño</h3>
              <p>
                Ayúdanos a optimizar tu tratamiento y observa tu evolución.
                Completa el cuestionario y OBTÉN 10€ A CAMBIO.
              </p>
              <br></br>
              <p>
                Las siguientes preguntas se refieren a tus HÁBITOS DE SUEÑO sólo
                durante el mes pasado. Tus respuestas deben reflejar la
                contestación más acertada para la mayoría de días y noches
                DURANTE LOS ÚLTIMOS 30 DÍAS. Por favor, contesta a todas las
                preguntas.
              </p>
              <br></br>

              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="psqiPreg001">
                    1. Durante el mes pasado, ¿a qué hora te has ido a la cama
                    habitualmente de noche?
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psqiPreg001"
                      required
                      type="time"
                      value={psqiPreg001}
                      onChange={(e) => setPsqiPreg001(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="psqiPreg002">
                    2. Durante el mes pasado, ¿cuánto tiempo (en minutos) has
                    tardado en dormirte habitualmente?
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psqiPreg002"
                      required
                      type="number"
                      value={psqiPreg002}
                      onChange={(e) => setPsqiPreg002(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="psqiPreg003">
                    3. Durante el mes pasado, ¿a qué hora te has levantado
                    habitualmente por la mañana?
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psqiPreg003"
                      required
                      type="time"
                      value={psqiPreg003}
                      onChange={(e) => setPsqiPreg003(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="psqiPreg004">
                    4. Durante el mes pasado, ¿cuántas horas calculas que habrás
                    dormido por la noche?
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psqiPreg004"
                      required
                      type="number"
                      value={psqiPreg004}
                      onChange={(e) => setPsqiPreg004(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <p>
                5. Durante el mes pasado, cuántas veces has tenido problemas
                para dormir a causa de...
              </p>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>No durante el mes pasado</p>
                    <p>Menos de una vez a la semana</p>
                    <p>Una o dos veces a la semana</p>
                    <p>Tres o más veces a la semana</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005a">
                      a. no poder conciliar el sueño en 30 minutos
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005a-0">
                        <input
                          id="psqiPreg005a-0"
                          name="psqiPreg005a"
                          type="radio"
                          value="0"
                          checked={psqiPreg005a === "0"}
                          onChange={(e) => setPsqiPreg005a(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005a-1">
                        <input
                          id="psqiPreg005a-1"
                          name="psqiPreg005a"
                          type="radio"
                          value="1"
                          checked={psqiPreg005a === "1"}
                          onChange={(e) => setPsqiPreg005a(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005a-2">
                        <input
                          id="psqiPreg005a-2"
                          name="psqiPreg005a"
                          type="radio"
                          value="2"
                          checked={psqiPreg005a === "2"}
                          onChange={(e) => setPsqiPreg005a(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005a-3">
                        <input
                          id="psqiPreg005a-3"
                          name="psqiPreg005a"
                          type="radio"
                          value="3"
                          checked={psqiPreg005a === "3"}
                          onChange={(e) => setPsqiPreg005a(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005b">
                      b. despertarme en mitad de la noche o de madrugada
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005b-0">
                        <input
                          id="psqiPreg005b-0"
                          name="psqiPreg005b"
                          type="radio"
                          value="0"
                          checked={psqiPreg005b === "0"}
                          onChange={(e) => setPsqiPreg005b(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005b-1">
                        <input
                          id="psqiPreg005b-1"
                          name="psqiPreg005b"
                          type="radio"
                          value="1"
                          checked={psqiPreg005b === "1"}
                          onChange={(e) => setPsqiPreg005b(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005b-2">
                        <input
                          id="psqiPreg005b-2"
                          name="psqiPreg005b"
                          type="radio"
                          value="2"
                          checked={psqiPreg005b === "2"}
                          onChange={(e) => setPsqiPreg005b(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005b-3">
                        <input
                          id="psqiPreg005b-3"
                          name="psqiPreg005b"
                          type="radio"
                          value="3"
                          checked={psqiPreg005b === "3"}
                          onChange={(e) => setPsqiPreg005b(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005c">
                      c. tener que levantarme para ir al servicio
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005c-0">
                        <input
                          id="psqiPreg005c-0"
                          name="psqiPreg005c"
                          type="radio"
                          value="0"
                          checked={psqiPreg005c === "0"}
                          onChange={(e) => setPsqiPreg005c(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005c-1">
                        <input
                          id="psqiPreg005c-1"
                          name="psqiPreg005c"
                          type="radio"
                          value="1"
                          checked={psqiPreg005c === "1"}
                          onChange={(e) => setPsqiPreg005c(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005c-2">
                        <input
                          id="psqiPreg005c-2"
                          name="psqiPreg005c"
                          type="radio"
                          value="2"
                          checked={psqiPreg005c === "2"}
                          onChange={(e) => setPsqiPreg005c(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005c-3">
                        <input
                          id="psqiPreg005c-3"
                          name="psqiPreg005c"
                          type="radio"
                          value="3"
                          checked={psqiPreg005c === "3"}
                          onChange={(e) => setPsqiPreg005c(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005d">
                      d. no poder respirar bien
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005d-0">
                        <input
                          id="psqiPreg005d-0"
                          name="psqiPreg005d"
                          type="radio"
                          value="0"
                          checked={psqiPreg005d === "0"}
                          onChange={(e) => setPsqiPreg005d(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005d-1">
                        <input
                          id="psqiPreg005d-1"
                          name="psqiPreg005d"
                          type="radio"
                          value="1"
                          checked={psqiPreg005d === "1"}
                          onChange={(e) => setPsqiPreg005d(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005d-2">
                        <input
                          id="psqiPreg005d-2"
                          name="psqiPreg005d"
                          type="radio"
                          value="2"
                          checked={psqiPreg005d === "2"}
                          onChange={(e) => setPsqiPreg005d(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005d-3">
                        <input
                          id="psqiPreg005d-3"
                          name="psqiPreg005d"
                          type="radio"
                          value="3"
                          checked={psqiPreg005d === "3"}
                          onChange={(e) => setPsqiPreg005d(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005e">
                      e. toser o roncar fuertemente
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005e-0">
                        <input
                          id="psqiPreg005e-0"
                          name="psqiPreg005e"
                          type="radio"
                          value="0"
                          checked={psqiPreg005e === "0"}
                          onChange={(e) => setPsqiPreg005e(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005e-1">
                        <input
                          id="psqiPreg005e-1"
                          name="psqiPreg005e"
                          type="radio"
                          value="1"
                          checked={psqiPreg005e === "1"}
                          onChange={(e) => setPsqiPreg005e(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005e-2">
                        <input
                          id="psqiPreg005e-2"
                          name="psqiPreg005e"
                          type="radio"
                          value="2"
                          checked={psqiPreg005e === "2"}
                          onChange={(e) => setPsqiPreg005e(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005e-3">
                        <input
                          id="psqiPreg005e-3"
                          name="psqiPreg005e"
                          type="radio"
                          value="3"
                          checked={psqiPreg005e === "3"}
                          onChange={(e) => setPsqiPreg005e(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005f">
                      f. sentir demasiado frío
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005f-0">
                        <input
                          id="psqiPreg005f-0"
                          name="psqiPreg005f"
                          type="radio"
                          value="0"
                          checked={psqiPreg005f === "0"}
                          onChange={(e) => setPsqiPreg005f(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005f-1">
                        <input
                          id="psqiPreg005f-1"
                          name="psqiPreg005f"
                          type="radio"
                          value="1"
                          checked={psqiPreg005f === "1"}
                          onChange={(e) => setPsqiPreg005f(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005f-2">
                        <input
                          id="psqiPreg005f-2"
                          name="psqiPreg005f"
                          type="radio"
                          value="2"
                          checked={psqiPreg005f === "2"}
                          onChange={(e) => setPsqiPreg005f(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005f-3">
                        <input
                          id="psqiPreg005f-3"
                          name="psqiPreg005f"
                          type="radio"
                          value="3"
                          checked={psqiPreg005f === "3"}
                          onChange={(e) => setPsqiPreg005f(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005g">
                      g. sentir demasiado calor
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005g-0">
                        <input
                          id="psqiPreg005g-0"
                          name="psqiPreg005g"
                          type="radio"
                          value="0"
                          checked={psqiPreg005g === "0"}
                          onChange={(e) => setPsqiPreg005g(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005g-1">
                        <input
                          id="psqiPreg005g-1"
                          name="psqiPreg005g"
                          type="radio"
                          value="1"
                          checked={psqiPreg005g === "1"}
                          onChange={(e) => setPsqiPreg005g(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005g-2">
                        <input
                          id="psqiPreg005g-2"
                          name="psqiPreg005g"
                          type="radio"
                          value="2"
                          checked={psqiPreg005g === "2"}
                          onChange={(e) => setPsqiPreg005g(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005g-3">
                        <input
                          id="psqiPreg005g-3"
                          name="psqiPreg005g"
                          type="radio"
                          value="3"
                          checked={psqiPreg005g === "3"}
                          onChange={(e) => setPsqiPreg005g(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005h">
                      h. tener malos sueños
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005h-0">
                        <input
                          id="psqiPreg005h-0"
                          name="psqiPreg005h"
                          type="radio"
                          value="0"
                          checked={psqiPreg005h === "0"}
                          onChange={(e) => setPsqiPreg005h(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005h-1">
                        <input
                          id="psqiPreg005h-1"
                          name="psqiPreg005h"
                          type="radio"
                          value="1"
                          checked={psqiPreg005h === "1"}
                          onChange={(e) => setPsqiPreg005h(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005h-2">
                        <input
                          id="psqiPreg005h-2"
                          name="psqiPreg005h"
                          type="radio"
                          value="2"
                          checked={psqiPreg005h === "2"}
                          onChange={(e) => setPsqiPreg005h(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005h-3">
                        <input
                          id="psqiPreg005h-3"
                          name="psqiPreg005h"
                          type="radio"
                          value="3"
                          checked={psqiPreg005h === "3"}
                          onChange={(e) => setPsqiPreg005h(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005i">
                      i. tener dolor
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005i-0">
                        <input
                          id="psqiPreg005i-0"
                          name="psqiPreg005i"
                          type="radio"
                          value="0"
                          checked={psqiPreg005i === "0"}
                          onChange={(e) => setPsqiPreg005i(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005i-1">
                        <input
                          id="psqiPreg005i-1"
                          name="psqiPreg005i"
                          type="radio"
                          value="1"
                          checked={psqiPreg005i === "1"}
                          onChange={(e) => setPsqiPreg005i(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005i-2">
                        <input
                          id="psqiPreg005i-2"
                          name="psqiPreg005i"
                          type="radio"
                          value="2"
                          checked={psqiPreg005i === "2"}
                          onChange={(e) => setPsqiPreg005i(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005i-3">
                        <input
                          id="psqiPreg005i-3"
                          name="psqiPreg005i"
                          type="radio"
                          value="3"
                          checked={psqiPreg005i === "3"}
                          onChange={(e) => setPsqiPreg005i(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>

                <div className="field exception-bg">
                  <div className="control grid--2col">
                    <label htmlFor="psqiPreg005j">
                      j. Otra razón (es), por favor descríbela (s)
                    </label>
                    <input
                      className="input"
                      type="text"
                      name="psqiPreg005j"
                      id="psqiPreg005j"
                      value={psqiPreg005j}
                      onChange={(e) => setPsqiPreg005j(e.target.value)}
                    />
                  </div>
                </div>

                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg005k">
                      Durante el mes pasado, ¿con qué frecuencia has tenido
                      problemas de sueño a causa de esto?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg005k-0">
                        <input
                          id="psqiPreg005k-0"
                          name="psqiPreg005k"
                          type="radio"
                          value="0"
                          checked={psqiPreg005k === "0"}
                          onChange={(e) => setPsqiPreg005k(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg005k-1">
                        <input
                          id="psqiPreg005k-1"
                          name="psqiPreg005k"
                          type="radio"
                          value="1"
                          checked={psqiPreg005k === "1"}
                          onChange={(e) => setPsqiPreg005k(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg005k-2">
                        <input
                          id="psqiPreg005k-2"
                          name="psqiPreg005k"
                          type="radio"
                          value="2"
                          checked={psqiPreg005k === "2"}
                          onChange={(e) => setPsqiPreg005k(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg005k-3">
                        <input
                          id="psqiPreg005k-3"
                          name="psqiPreg005k"
                          type="radio"
                          value="3"
                          checked={psqiPreg005k === "3"}
                          onChange={(e) => setPsqiPreg005k(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>Muy buena</p>
                    <p>Buena</p>
                    <p>Mala</p>
                    <p>Muy mala</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg006">
                      6. Durante el mes pasado, ¿cómo valorarías, en conjunto,
                      la calidad de tu sueño?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg006-0">
                        <input
                          id="psqiPreg006-0"
                          name="psqiPreg006"
                          type="radio"
                          value="0"
                          checked={psqiPreg006 === "0"}
                          onChange={(e) => setPsqiPreg006(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg006-1">
                        <input
                          id="psqiPreg006-1"
                          name="psqiPreg006"
                          type="radio"
                          value="1"
                          checked={psqiPreg006 === "1"}
                          onChange={(e) => setPsqiPreg006(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg006-2">
                        <input
                          id="psqiPreg006-2"
                          name="psqiPreg006"
                          type="radio"
                          value="2"
                          checked={psqiPreg006 === "2"}
                          onChange={(e) => setPsqiPreg006(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg006-3">
                        <input
                          id="psqiPreg006-3"
                          name="psqiPreg006"
                          type="radio"
                          value="3"
                          checked={psqiPreg006 === "3"}
                          onChange={(e) => setPsqiPreg006(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>No durante el mes pasado</p>
                    <p>Menos de una vez a la semana </p>
                    <p>Una o dos veces a la semana </p>
                    <p>Tres o más veces a la semana</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg007">
                      7. Durante el mes pasado, ¿cuántas veces has tomado
                      medicación (prescrita o de "parafarmacia") para dormir?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg007-0">
                        <input
                          id="psqiPreg007-0"
                          name="psqiPreg007"
                          type="radio"
                          value="0"
                          checked={psqiPreg007 === "0"}
                          onChange={(e) => setPsqiPreg007(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg007-1">
                        <input
                          id="psqiPreg007-1"
                          name="psqiPreg007"
                          type="radio"
                          value="1"
                          checked={psqiPreg007 === "1"}
                          onChange={(e) => setPsqiPreg007(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg007-2">
                        <input
                          id="psqiPreg007-2"
                          name="psqiPreg007"
                          type="radio"
                          value="2"
                          checked={psqiPreg007 === "2"}
                          onChange={(e) => setPsqiPreg007(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg007-3">
                        <input
                          id="psqiPreg007-3"
                          name="psqiPreg007"
                          type="radio"
                          value="3"
                          checked={psqiPreg007 === "3"}
                          onChange={(e) => setPsqiPreg007(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg008">
                      8. Durante el mes pasado, ¿cuántas veces has tenido
                      problemas para mantenerte despierto mientras conducías,
                      comías, o mantenías una actividad social?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg008-0">
                        <input
                          id="psqiPreg008-0"
                          name="psqiPreg008"
                          type="radio"
                          value="0"
                          checked={psqiPreg008 === "0"}
                          onChange={(e) => setPsqiPreg008(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg008-1">
                        <input
                          id="psqiPreg008-1"
                          name="psqiPreg008"
                          type="radio"
                          value="1"
                          checked={psqiPreg008 === "1"}
                          onChange={(e) => setPsqiPreg008(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg008-2">
                        <input
                          id="psqiPreg008-2"
                          name="psqiPreg008"
                          type="radio"
                          value="2"
                          checked={psqiPreg008 === "2"}
                          onChange={(e) => setPsqiPreg008(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg008-3">
                        <input
                          id="psqiPreg008-3"
                          name="psqiPreg008"
                          type="radio"
                          value="3"
                          checked={psqiPreg008 === "3"}
                          onChange={(e) => setPsqiPreg008(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>Ningún problema</p>
                    <p>Sólo un ligero problema</p>
                    <p>Algo de problema</p>
                    <p>Un grave problema</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg009">
                      9. Durante el mes pasado, ¿en qué medida ha sido un
                      problema mantener el ánimo para hacer lo que tenías que
                      hacer?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg009-0">
                        <input
                          id="psqiPreg009-0"
                          name="psqiPreg009"
                          type="radio"
                          value="0"
                          checked={psqiPreg009 === "0"}
                          onChange={(e) => setPsqiPreg009(e.target.value)}
                          required 
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg009-1">
                        <input
                          id="psqiPreg009-1"
                          name="psqiPreg009"
                          type="radio"
                          value="1"
                          checked={psqiPreg009 === "1"}
                          onChange={(e) => setPsqiPreg009(e.target.value)}
                          required 
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg009-2">
                        <input
                          id="psqiPreg009-2"
                          name="psqiPreg009"
                          type="radio"
                          value="2"
                          checked={psqiPreg009 === "2"}
                          onChange={(e) => setPsqiPreg009(e.target.value)}
                          required 
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg009-3">
                        <input
                          id="psqiPreg009-3"
                          name="psqiPreg009"
                          type="radio"
                          value="3"
                          checked={psqiPreg009 === "3"}
                          onChange={(e) => setPsqiPreg009(e.target.value)}
                          required 
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>No pareja o compañero de habitación</p>
                    <p>Pareja/ compañero en otra habitación</p>
                    <p>Pareja en misma habitación pero no misma cama</p>
                    <p>Pareja en la misma cama</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010">
                      10. ¿Tienes pareja o compañero de habitación?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010-0">
                        <input
                          id="psqiPreg010-0"
                          name="psqiPreg010"
                          type="radio"
                          value="0"
                          checked={psqiPreg010 === "0"}
                          onChange={(e) => setPsqiPreg010(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010-1">
                        <input
                          id="psqiPreg010-1"
                          name="psqiPreg010"
                          type="radio"
                          value="1"
                          checked={psqiPreg010 === "1"}
                          onChange={(e) => setPsqiPreg010(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010-2">
                        <input
                          id="psqiPreg010-2"
                          name="psqiPreg010"
                          type="radio"
                          value="2"
                          checked={psqiPreg010 === "2"}
                          onChange={(e) => setPsqiPreg010(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010-3">
                        <input
                          id="psqiPreg010-3"
                          name="psqiPreg010"
                          type="radio"
                          value="3"
                          checked={psqiPreg010 === "3"}
                          onChange={(e) => setPsqiPreg010(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <p>
                Si tienes pareja o compañero de habitación, pregúntale si
                durante el mes pasado has tenido...
              </p>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--4-col">
                    <p>No durante el mes pasado</p>
                    <p>Menos de una vez a la semana</p>
                    <p>Una o dos veces a la semana</p>
                    <p>Tres o más veces a la semana</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010a">
                      a. ronquidos fuertes
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010a-0">
                        <input
                          id="psqiPreg010a-0"
                          name="psqiPreg010a"
                          type="radio"
                          value="0"
                          checked={psqiPreg010a === "0"}
                          onChange={(e) => setPsqiPreg010a(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010a-1">
                        <input
                          id="psqiPreg010a-1"
                          name="psqiPreg010a"
                          type="radio"
                          value="1"
                          checked={psqiPreg010a === "1"}
                          onChange={(e) => setPsqiPreg010a(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010a-2">
                        <input
                          id="psqiPreg010a-2"
                          name="psqiPreg010a"
                          type="radio"
                          value="2"
                          checked={psqiPreg010a === "2"}
                          onChange={(e) => setPsqiPreg010a(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010a-3">
                        <input
                          id="psqiPreg010a-3"
                          name="psqiPreg010a"
                          type="radio"
                          value="3"
                          checked={psqiPreg010a === "3"}
                          onChange={(e) => setPsqiPreg010a(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010b">
                      b. grandes pausas entre respiraciones mientras duermes
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010b-0">
                        <input
                          id="psqiPreg010b-0"
                          name="psqiPreg010b"
                          type="radio"
                          value="0"
                          checked={psqiPreg010b === "0"}
                          onChange={(e) => setPsqiPreg010b(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010b-1">
                        <input
                          id="psqiPreg010b-1"
                          name="psqiPreg010b"
                          type="radio"
                          value="1"
                          checked={psqiPreg010b === "1"}
                          onChange={(e) => setPsqiPreg010b(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010b-2">
                        <input
                          id="psqiPreg010b-2"
                          name="psqiPreg010b"
                          type="radio"
                          value="2"
                          checked={psqiPreg010b === "2"}
                          onChange={(e) => setPsqiPreg010b(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010b-3">
                        <input
                          id="psqiPreg010b-3"
                          name="psqiPreg010b"
                          type="radio"
                          value="3"
                          checked={psqiPreg010b === "3"}
                          onChange={(e) => setPsqiPreg010b(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010c">
                      c. contracciones o sacudidas de piernas mientras duermes
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010c-0">
                        <input
                          id="psqiPreg010c-0"
                          name="psqiPreg010c"
                          type="radio"
                          value="0"
                          checked={psqiPreg010c === "0"}
                          onChange={(e) => setPsqiPreg010c(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010c-1">
                        <input
                          id="psqiPreg010c-1"
                          name="psqiPreg010c"
                          type="radio"
                          value="1"
                          checked={psqiPreg010c === "1"}
                          onChange={(e) => setPsqiPreg010c(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010c-2">
                        <input
                          id="psqiPreg010c-2"
                          name="psqiPreg010c"
                          type="radio"
                          value="2"
                          checked={psqiPreg010c === "2"}
                          onChange={(e) => setPsqiPreg010c(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010c-3">
                        <input
                          id="psqiPreg010c-3"
                          name="psqiPreg010c"
                          type="radio"
                          value="3"
                          checked={psqiPreg010c === "3"}
                          onChange={(e) => setPsqiPreg010c(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010d">
                      d. episodios de desorientación o confusión mientras
                      duermes
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010d-0">
                        <input
                          id="psqiPreg010d-0"
                          name="psqiPreg010d"
                          type="radio"
                          value="0"
                          checked={psqiPreg010d === "0"}
                          onChange={(e) => setPsqiPreg010d(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010d-1">
                        <input
                          id="psqiPreg010d-1"
                          name="psqiPreg010d"
                          type="radio"
                          value="1"
                          checked={psqiPreg010d === "1"}
                          onChange={(e) => setPsqiPreg010d(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010d-2">
                        <input
                          id="psqiPreg010d-2"
                          name="psqiPreg010d"
                          type="radio"
                          value="2"
                          checked={psqiPreg010d === "2"}
                          onChange={(e) => setPsqiPreg010d(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010d-3">
                        <input
                          id="psqiPreg010d-3"
                          name="psqiPreg010d"
                          type="radio"
                          value="3"
                          checked={psqiPreg010d === "3"}
                          onChange={(e) => setPsqiPreg010d(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>

                <div className="field exception-bg">
                  <div className="control grid--2col">
                    <label htmlFor="psqiPreg010e">
                      e. Otra razón (es), por favor descríbela (s)
                    </label>
                    <input
                      className="input"
                      type="text"
                      name="psqiPreg010e"
                      id="psqiPreg010e"
                      value={psqiPreg010e}
                      onChange={(e) => setPsqiPreg010e(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="psqiPreg010f">
                      Durante el mes pasado, ¿con qué frecuencia has tenido
                      problemas de sueño a causa de esto?
                    </label>
                    <div className="radio--4-col">
                      <label className="radio" htmlFor="psqiPreg010f-0">
                        <input
                          id="psqiPreg010f-0"
                          name="psqiPreg010f"
                          type="radio"
                          value="0"
                          checked={psqiPreg010f === "0"}
                          onChange={(e) => setPsqiPreg010f(e.target.value)}
                        />
                        0
                      </label>
                      <label className="radio" htmlFor="psqiPreg010f-1">
                        <input
                          id="psqiPreg010f-1"
                          name="psqiPreg010f"
                          type="radio"
                          value="1"
                          checked={psqiPreg010f === "1"}
                          onChange={(e) => setPsqiPreg010f(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="psqiPreg010f-2">
                        <input
                          id="psqiPreg010f-2"
                          name="psqiPreg010f"
                          type="radio"
                          value="2"
                          checked={psqiPreg010f === "2"}
                          onChange={(e) => setPsqiPreg010f(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="psqiPreg010f-3">
                        <input
                          id="psqiPreg010f-3"
                          name="psqiPreg010f"
                          type="radio"
                          value="3"
                          checked={psqiPreg010f === "3"}
                          onChange={(e) => setPsqiPreg010f(e.target.value)}
                        />
                        3
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && psqi.author === pacienteId && (
        <div id="actions">
          {psqiStatus === "draft" && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
        </div>
      )}
      <GananciasModal
        isOpen={isGananciasModalOpen}
        onClose={() => window.location.replace("../")}
        title="Ganancias obtenidas"
        message={gananciasMessage}
        buttonStyle="is-danger"
      />
    </>
  );
}
